import React from 'react';
import { motion, useTransform } from 'framer-motion';
import type { MotionValue } from 'framer-motion';
type ShowcaseWordProps = {
  word: string;
  index: number;
  progress: MotionValue<number>;
  reduced: boolean;
  /** Pixels of travel on reveal — reduced on mobile. */
  travel?: number;
  className?: string;
};

/**
 * A single editorial word in the pinned showcase. Each word owns its own slice
 * of the timeline so they cascade in rather than appearing as a block.
 */
export function ShowcaseWord({
  word,
  index,
  progress,
  reduced,
  travel = 28,
  className = ''
}: ShowcaseWordProps) {
  const start = 0.53 + index * 0.045;
  const opacity = useTransform(progress, [start, start + 0.07, 0.82, 0.92], [0, 1, 1, 0]);
  const y = useTransform(progress, [start, start + 0.09, 0.92], [travel, 0, -travel * 0.6]);
  return <motion.span style={reduced ? undefined : {
    opacity,
    y,
    willChange: 'transform, opacity'
  }} className={`block font-display text-[0.7rem] font-black uppercase tracking-[0.5em] text-white/85 sm:text-sm ${className}`} data-id="element-214" data-mp="124qmx6xs8oso">
      {word}
    </motion.span>;
}